import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react';
import { QualifierWizardStore } from './designer/qualifierWizard/qualifierWizardStore';
import { ConfigErrorWindow } from './designer/qualifierWizard/configErrorWindow';

export interface ExternalConfigErrorWindowProps {
	serviceId: string;
	elementId: string;
	qualifierId: string;
	name: string;
	top: number;
	left: number;
	width: number;
	height: number;
}

// Shows test results for an already-saved qualifier, outside the wizard's own edit session (e.g. from the
// service viewer's qualifier list) — so it builds a standalone QualifierWizardStore just to call getTest().
export const ExternalConfigErrorWindow = observer((props: ExternalConfigErrorWindowProps) => {
	const store = useMemo(
		() =>
			new QualifierWizardStore({
				serviceId: props.serviceId,
				elementId: props.elementId,
				qualifierId: props.qualifierId,
				onSave: () => {},
			}),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[],
	);

	useEffect(() => {
		void store.getTest();
		return () => store.destroy();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const fallbackPosition = { top: +props.top, left: +props.left, width: +props.width, height: +props.height };

	return <ConfigErrorWindow store={store} name={props.name} fallbackPosition={fallbackPosition} />;
});

export default ExternalConfigErrorWindow;
